/* Prev/next arrows on the main product image (desktop): they click the previous or next thumbnail,
   so Dawn's media-gallery keeps handling the active media, live region and thumbnail state. */
document.addEventListener('click', (event) => {
  const btn = event.target.closest('[data-lt-gallery-arrows] [data-dir]');
  if (!btn) return;
  const wrapper = btn.closest('.product__media-wrapper');
  const thumbs = [...wrapper.querySelectorAll('.thumbnail-list__item:not(.thumbnail-list_item--variant) .thumbnail')]
    .filter((t) => t.offsetParent !== null);
  if (thumbs.length < 2) return;
  const current = Math.max(0, thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true'));
  const next = (current + Number(btn.dataset.dir) + thumbs.length) % thumbs.length;
  thumbs[next].click();
});

/* Move the arrows into the main image viewer so they centre on the image, not on the whole column. */
const ltPlaceArrows = () => {
  document.querySelectorAll('[data-lt-gallery-arrows]').forEach((arrows) => {
    const viewer = arrows.closest('.product__media-wrapper')?.querySelector('[id^="GalleryViewer"]');
    if (viewer && arrows.parentElement !== viewer) {
      viewer.classList.add('lt-pdp-viewer');
      viewer.appendChild(arrows);
    }
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ltPlaceArrows);
else ltPlaceArrows();
